/**
 * Curated executive points of view — primarily LinkedIn posts.
 * Update when new POVs are published.
 */
export const linkedInPointOfViews = [
  {
    id: 'outcomes-per-token-board-kpi',
    title: 'Outcomes Per Token Is The Board-Level KPI',
    excerpt:
      "Shared Oxygen ran 3B tokens across frontier, mid-tier, and local LLMs as deliberate research into AI economics — roughly five developer-years of usage. Token volume is a poor proxy for value. Outcomes-per-token is the real board-level KPI, and model tier selection is a capital allocation decision. Not a usage story — an evidence story. Can you defend what you're spending?",
    url: 'https://www.linkedin.com/posts/sharedoxygen_ai-enterpriseai-cto-activity-7480464511028637696-imTu/',
    publishedDate: '2026-07-08',
    imageUrl: '/images/outcomes-per-token-linkedin.svg',
    imageAlt:
      'Outcomes Per Token Is The Board-Level KPI — Shared Oxygen AI economics research',
    source: 'LinkedIn',
    author: 'Jeffrey Collins',
  },
  {
    id: 'ip-indemnity-code-ownership',
    title: 'IP Indemnity And Code Ownership',
    excerpt:
      'Code ownership and IP indemnity terms decide who carries the exposure when the provenance of shipped code is questioned. That is a contract question for the executive team, not a detail to settle in the engineering backlog.',
    url: 'https://www.linkedin.com/posts/activity-7451053835034189824-VUgR/',
    publishedDate: '2026-04-17',
    imageUrl: '/images/ip-indemnity-code-ownership-linkedin.svg',
    imageAlt: 'IP Indemnity And Code Ownership — Shared Oxygen executive brief',
    source: 'LinkedIn',
    author: 'Jeffrey Collins',
  },
];
